import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-current-template',
  templateUrl: './current-template.component.html',
  styleUrls: ['./current-template.component.less']
})
export class CurrentTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
